import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

import { loadingService } from '~/services/loading';

import { Text } from '../../atoms/Text/view';

interface State {
  visible: boolean;
  title?: string;
  description?: string;
}

export default function LoadingProvider() {
  const [state, setState] = useState<State>({ visible: false });

  useEffect(() => {
    const unsubscribe = loadingService.subscribe(setState);
    return () => {
      unsubscribe();
    };
  }, []);

  if (!state.visible) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center animate-fade_in">
      <div className="bg-intense-01 rounded-large px-large py-medium flex flex-col items-center gap-smaller min-w-[260px] shadow-level3">
        <Loader2 className="animate-spin" size={36} color="#1D4733" />
        {state.title ? (
          <Text className="text-paragraphLG color-complement-01">{state.title}</Text>
        ) : null}
        {state.description ? (
          <Text className="text-bodySM color-intense-06">{state.description}</Text>
        ) : null}
      </div>
    </div>
  );
}
